import { Link } from "react-router-dom";

export default function MentionsLegales() {
  return (
    <div className="animate-fade-in">
      <section className="bg-oya-black pt-28 pb-12 md:pt-36 md:pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-serif text-3xl md:text-4xl font-bold text-white">Mentions légales</h1>
          <p className="mt-4 text-white/70 text-sm md:text-base">
            Conformément à la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-20 px-4 bg-white">
        <div className="max-w-4xl mx-auto space-y-10">
          <div>
            <h2 className="text-xl font-bold text-oya-black mb-4">1. Éditeur du site</h2>
            <div className="space-y-2 text-oya-gray-medium leading-relaxed">
              <p><strong className="text-oya-black">Nom commercial :</strong> OYA PHONE</p>
              <p><strong className="text-oya-black">Forme juridique :</strong> Entrepreneur individuel (micro-entreprise)</p>
              <p><strong className="text-oya-black">Adresse du siège :</strong> 7, Quélerec, 29840 Landunvez, France</p>
              <p><strong className="text-oya-black">Téléphone :</strong>{" "}
                <a href="tel:0651004790" className="text-oya-red hover:underline">06 51 00 47 90</a>
              </p>
              <p><strong className="text-oya-black">Email :</strong>{" "}
                <a href="mailto:oyaphone29@gmail.com" className="text-oya-red hover:underline">oyaphone29@gmail.com</a>
              </p>
              <p><strong className="text-oya-black">Numéro SIRET :</strong> 440 461 994 00020</p>
              <p><strong className="text-oya-black">Capital social :</strong> Sans objet (entreprise individuelle)</p>
              <p><strong className="text-oya-black">Numéro de TVA intracommunautaire :</strong> Non assujetti — TVA non applicable, article 293 B du CGI</p>
            </div>
          </div>

          <div>
            <h2 className="text-xl font-bold text-oya-black mb-4">2. Directeur de la publication</h2>
            <div className="space-y-2 text-oya-gray-medium leading-relaxed">
              <p><strong className="text-oya-black">Nom et prénom :</strong> RICHARD Fabrice</p>
              <p><strong className="text-oya-black">Qualité :</strong> Entrepreneur individuel, représentant légal d'OYA PHONE</p>
              <p>Contact :{" "}
                <a href="mailto:oyaphone29@gmail.com" className="text-oya-red hover:underline">oyaphone29@gmail.com</a>
              </p>
            </div>
          </div>

          <div>
            <h2 className="text-xl font-bold text-oya-black mb-4">3. Hébergement</h2>
            <div className="space-y-2 text-oya-gray-medium leading-relaxed">
              <p><strong className="text-oya-black">Hébergeur :</strong> Cloudflare, Inc.</p>
              <p><strong className="text-oya-black">Adresse :</strong> 101 Townsend Street, San Francisco, CA 94107, États-Unis</p>
              <p><strong className="text-oya-black">Site web :</strong>{" "}
                <a href="https://www.cloudflare.com" target="_blank" rel="nofollow noopener noreferrer" className="text-oya-red hover:underline">www.cloudflare.com</a>
              </p>
            </div>
          </div>

          <div>
            <h2 className="text-xl font-bold text-oya-black mb-4">4. Propriété intellectuelle</h2>
            <p className="text-oya-gray-medium leading-relaxed">
              L'ensemble des contenus du site (textes, images, logos, icônes, mise en page) est la propriété exclusive d'OYA PHONE.
              Toute reproduction, représentation ou diffusion, totale ou partielle, est interdite sans autorisation écrite préalable.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-oya-black mb-4">5. Liens affiliés</h2>
            <p className="text-oya-gray-medium leading-relaxed">
              Ce site peut contenir des liens affiliés vers des plateformes tierces. Si vous cliquez sur un lien affilié et effectuez
              un achat, OYA PHONE peut percevoir une commission. Cela ne modifie en rien le prix payé.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-oya-black mb-4">6. Responsabilité</h2>
            <p className="text-oya-gray-medium leading-relaxed">
              OYA PHONE s'efforce de fournir des informations exactes et à jour. Toutefois, des erreurs ou omissions peuvent subsister.
              OYA PHONE ne saurait être tenue responsable des dommages directs ou indirects résultant de l'utilisation du site ou des
              sites tiers accessibles par liens.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-oya-black mb-4">7. Données personnelles</h2>
            <p className="text-oya-gray-medium leading-relaxed">
              Le site OYA PHONE ne collecte aucune donnée personnelle directement. Pour plus de détails, consultez la{" "}
              <Link to="/politique-de-confidentialite" className="text-oya-red hover:underline">Politique de confidentialité</Link>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}